import React, { useEffect, useCallback } from 'react';

const TermsModal = ({ isOpen, onClose, onAccept }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;
    
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b">
          <h2 className="text-2xl font-bold text-gray-900">用户协议与隐私政策</h2>
        </div>
        
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="space-y-6 text-gray-700">
            <section>
              <h3 className="text-lg font-semibold mb-3">服务说明</h3>
              <p className="mb-3">
                简历匹配度评估助手（以下简称"本服务"）是一个专业的简历与岗位匹配度分析工具，帮助用户优化简历、提升求职竞争力。
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">数据处理说明</h3>
              <p className="mb-3">
                为了提供服务，我们需要处理您的简历数据：
              </p>
              <ul className="list-disc pl-6 mb-3 space-y-1">
                <li>您的简历内容会被安全地上传到我们的服务器，但是我们不保存</li>
                <li>我们会使用第三方AI服务进行简历匹配度分析</li>
                <li>分析过程包括对简历内容进行智能解析和评估</li>
                <li>我们会生成详细的匹配度报告，帮助您了解简历的优势和不足</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">隐私保护承诺</h3>
              <p className="mb-3">
                我们高度重视您的隐私安全：
              </p>
              <ul className="list-disc pl-6 mb-3 space-y-1">
                <li><strong>不存储：</strong>我们不会在服务器中存储您的原始简历内容</li>
                <li><strong>仅保留结果：</strong>我们仅保留您的评估记录和匹配度结果，您可以在页面上随时删除</li>
                <li><strong>加密传输：</strong>所有数据传输都采用加密方式</li>
                <li><strong>安全存储：</strong>评估结果采用安全方式存储</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">数据使用范围</h3>
              <p className="mb-3">
                我们对您的数据使用有严格的限制：
              </p>
              <ul className="list-disc pl-6 mb-3 space-y-1">
                <li>仅用于简历匹配度分析和评估</li>
                <li>不会将您的简历内容用于其他商业目的</li>
                <li>不会向第三方出售或分享您的简历信息</li>
                <li>不会使用您的简历进行广告推送</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">用户权利</h3>
              <p className="mb-3">
                您对自己的数据拥有完全的控制权：
              </p>
              <ul className="list-disc pl-6 mb-3 space-y-1">
                <li>可以随时查看自己的评估记录</li>
                <li>可以删除个人数据和评估记录</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">用户责任</h3>
              <ul className="list-disc pl-6 mb-3 space-y-1">
                <li>不得上传违法、不良信息</li>
                <li>不得侵犯他人知识产权</li>
                <li>妥善保管账户信息</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">服务变更与终止</h3>
              <p className="mb-3">
                我们保留修改服务条款的权利，如有重大变更会提前通知用户。用户如不同意变更，可以停止使用服务并删除账户。
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold mb-3">联系方式</h3>
              <p className="mb-3">
                如对本协议有任何疑问，或需要行使您的数据权利，请通过以下方式联系我们：
              </p>
              <p className="text-sm text-gray-600">
                邮箱：support@resume-matcher.com<br />
                我们会在收到您的请求后尽快回复。
              </p>
            </section>
          </div>
        </div>

        <div className="p-6 border-t bg-gray-50 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            关闭
          </button>
          <button
            onClick={onAccept}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            同意并继续
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;